import { timezoneNames } from '@progress/kendo-date-math';
import '@progress/kendo-date-math/tz/America/Los_Angeles';
import '@progress/kendo-date-math/tz/America/New_York';
import '@progress/kendo-date-math/tz/Asia/Dubai';
import '@progress/kendo-date-math/tz/Asia/Tokyo';
import '@progress/kendo-date-math/tz/Etc/UTC';
import '@progress/kendo-date-math/tz/Europe/Madrid';
import '@progress/kendo-date-math/tz/Europe/Sofia';
import { guid } from '@progress/kendo-react-common';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import {
  IntlProvider,
  load,
  loadMessages,
  LocalizationProvider,
} from '@progress/kendo-react-intl';
import { Popup } from '@progress/kendo-react-popup';
import {
  AgendaView,
  DayView,
  MonthView,
  Scheduler,
  SchedulerEditItem,
  TimelineView,
  WeekView,
} from '@progress/kendo-react-scheduler';
import '@progress/kendo-theme-bootstrap/dist/all.css';
// import '@progress/kendo-theme-default/dist/all.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import esMessages from '../es.json';
import {
  customData,
  customModelFields,
  displayDate,
  sampleData,
  sampleDataWithCustomSchema,
} from '../events-utc';
import '../kendo.css';
import { FormWithCustomEditor } from './custom-form';
import { CustomItem, EditItemWithDynamicTitle } from './custom-item';
import * as Toasts from '../../../common/Toastify';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { setCurrentSchedularDate, setencounterCalculation, setGrouping, setJobEncounterOccurreneUpdateList } from '../../../JobOpportunity/slice';
import { getFilterDailyEncounter } from '../../../JobOpportunity/action';
import useConfiguration from '../../../../hooks/useConfiguration';
import { pageUrl } from '../../../../helpers/data';
import { useLocation } from 'react-router-dom';
loadMessages(esMessages, 'es-ES');


function KendoSchedulerDailyEncounter({
  multiShiftData,
  handleSave,
  startDate,
  grouping = { default: false, resources: [], group: [] },
  handleActions,
  editable
}) {
  const location = useLocation();
  const pathName = location.pathname
  const [ schedularDate, setSchdeularDate] = useState(new Date());
  // Height calcualtion:
const defaultHeight = 600
const defaultSchedularHeight = 488.8;
const headerAndFooterHeight = defaultHeight - defaultSchedularHeight;
const defaultSlot = 10;
const headerSlot = 2;
const slotPerHeight = defaultSchedularHeight / defaultSlot;
const expectedHours = 8 
const hourPerSlot = 4;
const expectedHoursInSlot = expectedHours * hourPerSlot
const expectedHeight = ((expectedHoursInSlot + headerSlot) * slotPerHeight) + headerAndFooterHeight 
const startOfDay= schedularDate ;
const endOfDay =  new Date(moment(schedularDate)?.set({ hour: 23, minute: 45, second: 0, millisecond: 0 }));
const timeDifferenceInMilliseconds = endOfDay - startOfDay;
const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60);
const timeDifferenceSlotHeight = headerAndFooterHeight + (headerSlot * slotPerHeight) + (timeDifferenceInHours * hourPerSlot * slotPerHeight)


  const timezones = React.useMemo(() => timezoneNames(), []);
  const locales = [
    {
      language: 'en-US',
      locale: 'en',
    },
    {
      language: 'es-ES',
      locale: 'es',
    },
  ];
  const [view, setView] = React.useState('day');
  const [date, setDate] = React.useState();
  const [locale, setLocale] = React.useState(locales[0]);
  const [showCurrentDate, setShowCurrentDate] = React.useState(true)
  // const [timezone, setTimezone] = React.useState('Etc/UTC');
  // const [orientation, setOrientation] = React.useState('horizontal');
  const [data, setData] = React.useState();
  const dispatch = useDispatch()
  const authorizedUserList = useSelector(state => state.jobOpportunity?.selectedAuthUsers);
  const currentSchedularDate = useSelector(state => state.jobOpportunity?.currentSchedularDate);
  const config = useConfiguration();
  // console.log({authorizedUserList});
  const handleViewChange = React.useCallback(
    (event) => {
      setView(event.value);
    },
    [setView]
  );
  const getShedule = (updatedDate, authorizedUserList) => {
    dispatch(
      setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
    );

    dispatch(setGrouping({ key: "group", value: [] }));
    dispatch(setGrouping({ key: "resources", value: [] }));
    // dispatch(setCandidateSearch({ key: "fromDate", value: "" }));
    // dispatch(setCandidateSearch({ key: "toDate", value: "" }));
    // dispatch(setCandidateSearch({ key: "candidates", value: "" }));
    dispatch(setencounterCalculation([]))
    console.log({ authorizedUserList });
    if ((!authorizedUserList?.length > 0)) {
      Toasts.error("Please select Authorized User");
      return
    }

    const reauest = {
      "jobsShiftUniqueId": null,
      "candidates": [
        ...new Set(
          authorizedUserList.map((element) => element.value)
        ),
      ],
      "fromDate": updatedDate,
      "toDate": updatedDate
    }

    dispatch(
      getFilterDailyEncounter(config.baseUrl, reauest)
    ).then((resource) => {
      console.log(resource);
      if (resource && resource.length) {
        const groupArray = [
          ...new Set(
            resource.map((element, index) => {
              return element.name;
            })
          ),
        ];
        dispatch(setGrouping({ key: "group", value: groupArray }));
        dispatch(setGrouping({ key: "resources", value: resource }));
      }
    })
  }
  const handleDateChange = React.useCallback(
    (event) => {
      // console.log(event);
      // if (!event.isTrusted) {
      //   setDate(event.value);
      // }
      // console.log({eventValue:event.value,event});
      if (event.value && grouping.changeCurrentSchedularDate && config && authorizedUserList) {
        getShedule(moment(event?.value?._localDate ? event?.value?._localDate : event.value).format("YYYY-MM-DD"), authorizedUserList)
        dispatch(setCurrentSchedularDate(moment(event?.value?._localDate ? event?.value?._localDate : event.value).format("YYYY-MM-DD")))
      }
      // if(new Date().setHours(0,0,0,0) !== new Date(event.value).setHours(0,0,0,0)){
      //   setShowCurrentDate(false)
      // } else {
      //   setShowCurrentDate(true)
      // }
      const schedularUpdatedDate = (moment(event.value).format("YYYY-MM-DD") !== moment(new Date()).format("YYYY-MM-DD")) ? event.value : new Date();
      setDate(event.value);
      setSchdeularDate(schedularUpdatedDate);
    },
    [setDate, authorizedUserList, config]
  );
useEffect(() => {
  if(date){
    if(new Date().setHours(0,0,0,0) !== new Date(date).setHours(0,0,0,0)){
      setShowCurrentDate(false)
    } else {
      setShowCurrentDate(true)
    }
  }
},[date])
  useEffect(() => {
    setData((prevState) => {
      return multiShiftData.map((element) => {
        const { Start, End, Title, ...rest } = element;
        return {
          ...rest,
          Start: new Date(Start),
          End: new Date(End),
        };
      });
    });
    return () => { };
  }, [multiShiftData]);
  // console.log({currentSchedularDate,date, main:new Date(currentSchedularDate) });
  useEffect(() => {
    setDate((preValue) => {
      // return (currentSchedularDate ) ? new Date(currentSchedularDate) : startDate ? new Date(startDate) : new Date();
      return (currentSchedularDate && grouping.changeCurrentSchedularDate) ? new Date(moment(currentSchedularDate).utc()) : startDate ? new Date(startDate) : new Date();
    });
 
    return () => { };
  }, [startDate, currentSchedularDate]);
  
  // useEffect(() => {
  //   console.log({startDate});
  //  if(startDate){
  //   if(new Date().setHours(0,0,0,0) !== new Date(startDate).setHours(0,0,0,0)){
  //     setShowCurrentDate(false)
  //   } else {
  //     setShowCurrentDate(true)
  //   }
  //  }
  // },[startDate])
  // console.log({currentSchedularDate});
  // console.log(Intl.DateTimeFormat().resolvedOptions().timeZone)

  // const handleLocaleChange = React.useCallback(
  //   (event) => {
  //     setLocale(event.target.value);
  //   },
  //   [setLocale]
  // );
  // const handleTimezoneChange = React.useCallback(
  //   (event) => {
  //     setTimezone(event.target.value);
  //   },
  //   [setTimezone]
  // );
  // const handleOrientationChange = React.useCallback((event) => {
  //   setOrientation(event.target.getAttribute('data-orientation'));
  // }, []);
  const handleDataChange = React.useCallback(
    ({ created, updated, deleted }) => {

      // console.log({ created, updated, deleted });
      if (created?.length > 0) {
        const currentDate = new Date();
        const checkDate = new Date(created[0]?.Start)
        if (checkDate < currentDate) {
          Toasts.warning(`Please select future Date and Time`);
          return
        }
      }
      if (updated?.length > 0) {
        if (updated[0]?.IsClaimed) {
          Toasts.warning(`This encounter is claimed, cannot move/edit to other shift`);
          return
        }
      }

      if (updated?.length > 0) {
        updated.map(item => {
          item.isUnclaimedOccurrence = false;
        })
      }
      // console.log(updated);
      handleActions({ created, updated, deleted });
      setData((old) => {
        const newValue = old
          ?.filter(
            (item) =>
              deleted.find((current) => current.TaskID === item.TaskID) ===
              undefined
          )
          .map(
            (item) =>
              updated.find((current) => current.TaskID === item.TaskID) || item
          )
          .concat(
            created.map((item) =>
              Object.assign({}, {
                ...item, isCheckedIn: false,
                isCheckedOut: false, isNewSlot: true
              }, {
                TaskID: guid(),
              })
            )
          );
        handleSave(newValue);
        return newValue;
      });
    },
    [setData]
  );

  const group = {
    resources: grouping.group,
    orientation: 'horizontal',
  };

  const resources = grouping.resources;

  // useEffect(() => {
  //   if(!grouping.showNextPrevious){
  //     let getSchedularNavigation = document.querySelectorAll('span .k-scheduler-navigation > button');
  //     // console.log({getSchedularNavigation:getSchedularNavigation.childNodes});
  //     getSchedularNavigation?.forEach(item => {
  //       // console.log(item?.getAttribute('aria-label'));
  //       if( item?.getAttribute('aria-label') !== "Today" ){
  //         // console.log({item});
  //         item.classList.add('hide-previous-next')
  //       }else{
  //         item.classList.add('today-border')
  //       }
  //     })
  //   }
  // },[])

  return (
    <div>
      <LocalizationProvider language={locale.language}>
        <IntlProvider locale={locale.locale}>
          <Scheduler
          // height={!!authorizedUserList.length ? (expectedHeight + slotPerHeight) : timeDifferenceSlotHeight  }
          height={ view !== "month" ? expectedHours <= timeDifferenceInHours ? !!authorizedUserList.length ? (expectedHeight + slotPerHeight) : expectedHeight : !!authorizedUserList.length ? (timeDifferenceSlotHeight + slotPerHeight) : timeDifferenceSlotHeight : defaultHeight  }
            data={data}
            onDataChange={handleDataChange}
            view={view}
            onViewChange={handleViewChange}
            date={date}
            onDateChange={handleDateChange}
            editable={editable ? editable : true}
            modelFields={customModelFields}
            form={FormWithCustomEditor}
            editItem={EditItemWithDynamicTitle}
            item={CustomItem}
            group={grouping.default ? group : []}
            resources={grouping.default ? resources : []}
          >
            {/* <TimelineView /> */}
            <DayView
              showWorkHours={false}
              slotDuration={15}
              slotDivisions={1}
              startTime={(showCurrentDate && pathName !== pageUrl.dailyEncounter) ? new Date() :""}
              // startTime={ new Date().setHours(0,0,0,0) === new Date(date).setHours(0,0,0,0) ? new Date() : ""}
            />

            {grouping.showWeek && (
              <WeekView
                showWorkHours={false}
                slotDuration={15} 
                slotDivisions={1}
                startTime={(showCurrentDate &&  pathName !== pageUrl.dailyEncounter) ? new Date() :""}
                />
            )}
            {grouping.showMonth && <MonthView />}
            {/* <AgendaView /> */}
          </Scheduler>
        </IntlProvider>
      </LocalizationProvider>
    </div>
  );
}

export default KendoSchedulerDailyEncounter;
